import { Link } from 'react-router-dom';
import FaqAccordion from '@/components/feature/FaqAccordion';

export default function FaqPreview() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-widest text-secondary-700">
            <span className="inline-block h-2 w-2 rounded-full bg-secondary-500"></span>常见问题
          </p>
          <h2 className="font-heading mt-3 text-2xl text-foreground-950 md:text-4xl">
            追更常见问题
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            关于同步更新进度、汉化进度与抢先看，你可能想知道的都在这里。
          </p>
        </div>

        <div className="mt-8">
          <FaqAccordion limit={4} />
        </div>

        <div className="mt-6 text-center">
          <Link
            to="/faq"
            className="inline-flex items-center whitespace-nowrap rounded-full border border-primary-200 px-6 py-3 text-sm font-bold text-primary-600 transition-colors hover:bg-primary-50"
          >
            查看全部常见问题 <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}